import { configService } from './config.service';
const { prefixUrl, redirectUri } = await configService.appConfig;
const checkUserSession = async () => {
    // store the original url in the session storage
    let url;
    if (window.location.pathname !== '/') {
        url = window.location.pathname;
    }
    else {
        url = '/';
    }
    sessionStorage.setItem('original-url', url);
    // Get the auth status from the server
    const response = await fetch(`${prefixUrl}/users/me`, {
        credentials: 'include',
    });
    const responseBody = await response.json();
    // If the user was successfully authenticated in the server, get the system config and set the auth state
    // (note that at this point the cookie is already set)
    if (responseBody.userInfo) {
        return {
            status: 'Authenticated',
            name: responseBody.userInfo.name || responseBody.userInfo.preferred_username,
            logout: () => securityService.logoutUser(),
        };
    }
    else {
        return {
            status: 'Unauthenticated',
        };
    }
};
const inititateUserAuth = async () => {
    const response = await fetch(`${prefixUrl}/login?redirect_uri=${redirectUri}`, {
        method: 'GET',
        credentials: 'include',
    });
    const responseBody = await response.json();
    const loginUrl = responseBody.authLocation;
    if (loginUrl) {
        return loginUrl;
    }
    else {
        throw new Error('Invalid redirection');
    }
};
const completeUserAuth = async () => {
    let auth = {
        status: 'Unauthenticated',
    };
    let searchParamsStr;
    const url = window.location.href.toString();
    const separatorChar = url.indexOf('#') >= 0 ? '#' : '?';
    if (url.includes(separatorChar)) {
        searchParamsStr = url.substring(url.indexOf(separatorChar));
    }
    const response = await fetch(`${prefixUrl}/login${searchParamsStr}&redirect_uri=${redirectUri}`, {
        method: 'GET',
        credentials: 'include',
    });
    const responseBody = await response.json();
    // If the user was successfully authenticated in the server, get the system config and set the auth state
    // (note that at this point the cookie is already set)
    if (responseBody.userInfo) {
        // const systemConfigResponse = await configurationSvc.getSystemConfiguration();
        auth = {
            status: 'Authenticated',
            name: responseBody.userInfo.name || responseBody.userInfo.preferred_username,
            // systemConfig: systemConfigResponse.body,
            logout: () => securityService.logoutUser(),
        };
        // Restore the original url from the session storage (if any)
        const storedUrl = sessionStorage.getItem('original-url');
        sessionStorage.removeItem('original-url');
        if (storedUrl != null) {
            window.history.replaceState(null, '', storedUrl);
        }
        else {
            window.history.replaceState(null, '', '/');
        }
    }
    else {
        auth = {
            status: 'Unauthenticated',
        };
    }
    return auth;
};
const logoutUser = async () => {
    const response = await fetch(`${prefixUrl}/logout`, {
        method: 'POST',
        credentials: 'include',
    });
    const data = await response.json();
    window.location.href = data.redirectUrl;
};
const securityService = {
    checkUserSession,
    inititateUserAuth,
    completeUserAuth,
    logoutUser,
};
export { securityService };
